import * as actionTypes from 'containers/PageHeader/ExportModal/action-types';

export const changeEmail = (value) => ({
  type: actionTypes.EMAIL_CHANGE,
  payload: value,
});

export const open = (value) => ({
  type: actionTypes.OPEN,
  payload: value,
});

export const setSelection = (key) => ({
  type: actionTypes.SELECTION_SET,
  payload: key,
});

export const setShow = (payload) => ({
  type: actionTypes.SHOW,
  payload,
});

export const setIsLoadingState = (payload: boolean) => ({
  type: actionTypes.IS_LOADING_STATE_SET,
  payload,
});

export const setIsExportState = (payload: boolean) => ({
  type: actionTypes.IS_EXPORT_STATE_SET,
  payload,
});

export const setExportResult = (payload: boolean) => ({
  type: actionTypes.EXPORT_RESULT_SET,
  payload,
});

export const setExportType = (payload: string) => ({
  type: actionTypes.SET_EXPORT_TYPE,
  payload,
});

export const resetExportType = () => ({
  type: actionTypes.RESET_EXPORT_TYPE,
});
